
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./publisher.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/publisher/src/publisher-ui/publisher.scss
// module id = OgVx
// module chunks = 0